import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Circle Radius Calculator - Calculate Circle Radius';
const DESCRIPTION = 'The Circle Radius Calculator calculates the radius of a circle using information such as the diameter, circumference, or area of the circle.';
const KEYWORDS = 'Circle radius, Calculate circle radius, Circle calculator';
const OG_URL = 'https://do-calculate.com/calculator/en/circle-radius';
function CircleRadiusCalculator() {
    const [diameter, setDiameter] = useState('');
    const [circumference, setCircumference] = useState('');
    const [area, setArea] = useState('');
    const [radius, setRadius] = useState('');
    const [error, setError] = useState('');
    const handleCalculate = () => {
        if (!diameter && !circumference && !area) {
            setError('Please enter valid information (diameter, circumference, or area)');
            setRadius('');
            return;
        }
        if (diameter) {
            const diameterValue = parseFloat(diameter);
            if (!isNaN(diameterValue) && diameterValue >= 0) {
                setRadius((diameterValue / 2).toFixed(2));
                setError('');
                return;
            }
        }
        if (circumference) {
            const circumferenceValue = parseFloat(circumference);
            if (!isNaN(circumferenceValue) && circumferenceValue >= 0) {
                setRadius((circumferenceValue / (2 * Math.PI)).toFixed(2));
                setError('');
                return;
            }
        }
        if (area) {
            const areaValue = parseFloat(area);
            if (!isNaN(areaValue) && areaValue >= 0) {
                setRadius(Math.sqrt(areaValue / Math.PI).toFixed(2));
                setError('');
                return;
            }
        }
        setError('Please enter valid information (diameter, circumference, or area)');
        setRadius('');
    };
    return (
        <div className="ltr">
            <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
            <div className="row">
                <div className="col-12 col-md-8">
                    <FirstAds />
                </div>
            </div>
            <div className="row">
                <div className="col-12 col-md-8">
                    <br />
                    <div className="bg-success text-white text-center" style={{ height: '40px' }}>
                        <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
                    </div>
                            <div className="border border-light">
                                <div className="row">
                                    <div>
                                        <h2 style={{ fontSize: '18px' }}>How to Calculate Circle Radius</h2>
                                        <p>
                                            You can calculate the radius of a circle using the following information:
                                        </p>
                                        <ol>
                                            <li>
                                                If the diameter (d) is available in the data, you can calculate the radius using the following formula:
                                                <br />
                                                Radius = Diameter / 2
                                            </li>
                                            <li>
                                                If the circumference (C) value is available, you can calculate the radius using the formula:
                                                <br />
                                                Radius = Circumference / (2 × π)
                                            </li>
                                            <li>
                                                If the area (A) value is available, you can calculate the radius using the formula:
                                                <br />
                                                Radius = √(Area / π)
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                                 <MobileUnderCalAds/>
                                <div className="row">
                                    <div className="col-sm-12 col-md-7 calculatorStyle">
                                        <div className='p-3 mb-2 bg-success text-white'>
                                            <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                                        </div>
                                        <hr />
                                        <div dir="ltr">
                                            <div>
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Diameter (d)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="If diameter is available"
                                                        value={diameter}
                                                        onChange={(e) => setDiameter(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Circumference (C)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="If circumference is available"
                                                        value={circumference}
                                                        onChange={(e) => setCircumference(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <div className="form-group d-flex align-items-center">
                                                    <b>
                                                        <label className="form-label ms-2">Area (A)</label>
                                                    </b>
                                                    <input
                                                        type="number"
                                                        placeholder="If area is available"
                                                        value={area}
                                                        onChange={(e) => setArea(e.target.value)}
                                                        className="form-control"
                                                        style={{ width: '150px' }}
                                                    />
                                                </div>
                                                <br />
                                                <button
                                                    className="btn btn-success"
                                                    style={{ fontSize: '20px' }}
                                                    onClick={handleCalculate}
                                                >
                                                    Calculate Circle Radius
                                                </button>
                                            </div>
                                            <br />
                                            <div>
                                                {error !== '' ? (
                                                    <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                                                ) : (
                                                    <>
                                                        {radius !== '' && (
                                                            <>
                                                                <p className='p-3 mb-2 bg-success text-white'>
                                                                    Circle Radius:
                                                                </p>
                                                                <p className='p-3 mb-2 bg-info text-black'>{radius} cm</p>
                                                            </>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <RelatedLinks />
                                    <hr />
                                </div>
                            </div>
                </div>
                <div className="col" >
                    <SecondAds />
                    <br />
                    <MainCalculatorsList CalculatorsTypeId={CalculatorsType.mathCalculators}></MainCalculatorsList>
                    <br />
                </div>
            </div>
             <br />
        </div>
    );
}
export default CircleRadiusCalculator;
